import { render } from "./credit.vue?vue&type=template&id=3cc7528a&scoped=true&ts=true"
import script from "./credit.vue?vue&type=script&lang=ts"
export * from "./credit.vue?vue&type=script&lang=ts"

import "./credit.vue?vue&type=style&index=0&id=3cc7528a&lang=scss&scoped=true"

import exportComponent from "D:\\项目\\template\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cc7528a"]])

export default __exports__